<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'task-analysis-table-6';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.task-analysis-table-6 {
  --header-cell-height: 50px;
  --body-cell-height: 45px;
  $border: 2pt solid #c0bec7;
  border-left: $border;
  border-right: $border;
  thead {
    tr {
      &:first-child {
        &::after {
          @include _custom_table_bg;
          background: var(--theme-color-1);
          z-index: 1;
        }
        th {
          & > div {
            color: #fff;
          }
        }
        .gap {
          & > div {
            padding-bottom: $headerHeight;
          }
          &:has(+ .normal),
          &:first-child {
            & > div {
              border-right: $border;
            }
          }
        }
      }
    }
  }
  tbody {
    tr {
      border-top: $border;
      &:last-child {
        border-bottom: $border;
      }
      td {
        &:nth-child(1),
        &:nth-child(3) {
          div {
            border-right: $border;
          }
        }
      }
    }
  }
}
</style>
